<template>
  <b-card no-body class="notification-widget w-100">
    <template #header>
      <div class="d-flex justify-content-between">
        <span>Notifications</span>
        <span>
          <b-spinner v-if="loading" small />
          <b-badge
            v-else
            :variant="notifications.length ? 'warning' : null"
            pill
            >{{ notifications.length }}</b-badge
          >
        </span>
      </div>
    </template>
    <b-skeleton-wrapper :loading="loading">
      <b-list-group flush>
        <b-list-group-item v-if="notifications && !notifications.length">
          <slot name="no-results">
            <em>You have no notifications</em>
          </slot>
        </b-list-group-item>

        <NotificationsWidgetItem
          :notification="notification"
          v-for="notification in notifications.slice(0, showInitial)"
          :key="`${notification.target_id},${notification.trigger_type}`"
        />

        <template v-if="notifications.length > showInitial">
          <b-collapse id="hidden-items" v-model="showHidden">
            <NotificationsWidgetItem
              :notification="notification"
              v-for="notification in notifications.slice(showInitial)"
              :key="`${notification.target_id},${notification.trigger_type}`"
            />
          </b-collapse>
          <b-button variant="link" v-b-toggle.hidden-items>{{
            toggleButtonText
          }}</b-button>
        </template>
      </b-list-group>
      <template #loading>
        <b-list-group flush>
          <b-list-group-item v-for="n in showInitial" :key="$id(n)">
            <div class="d-flex w-100 align-items-center">
              <div class="d-flex flex-column align-items-start w-100">
                <div
                  class="d-flex w-100 justify-content-between align-items-baseline"
                >
                  <b-skeleton :width="`${getRndInteger(25, 75)}%`"></b-skeleton>
                </div>
              </div>
            </div>
          </b-list-group-item>
        </b-list-group>
      </template>
    </b-skeleton-wrapper>
  </b-card>
</template>

<script>
import NotificationsWidgetItem from "./NotificationsWidgetItem.vue";
export default {
  components: { NotificationsWidgetItem },
  name: "NotificationWidget",
  data() {
    return {
      showHidden: false,
    };
  },
  props: {
    notifications: {
      required: true,
      validator: (prop) => typeof Array.isArray(prop) || prop === null,
    },
    loading: {
      type: Boolean,
    },
    showInitial: {
      type: Number,
      required: false,
      default: 2,
    },
  },
  computed: {
    toggleButtonText() {
      if (!this.notifications?.length) return "";
      if (this.showHidden) {
        return "Collapse";
      }
      return `Show ${this.notifications.length - this.showInitial} more`;
    },
  },
  methods: {
    getRndInteger(min, max) {
      return Math.floor(Math.random() * (max - min + 1)) + min;
    },
    getIcon(notification) {
      if (notification.trigger_type === "reply") {
        return ["far", "comments"];
      }
      if (notification.trigger_type === "cp,,emt") {
        return ["far", "comment"];
      }
      return [];
    },
    getMsg(notification) {
      if (notification.trigger_type === "reply") {
        if (notification.count > 1) {
          return `${notification.count} replies on`;
        }
        return "1 reply on";
      }

      if (notification.trigger_type === "comment") {
        if (notification.count > 1) {
          return `${notification.count} comments on`;
        }
        return "1 comment on";
      }

      return "Unknown notification";
    },
  },
};
</script>

<style lang="less">
.notification-widget {
  flex: 1 1 auto;

  @media (max-width: 768px) {
    .list-group-item {
      font-size: 14px;
      padding: 0.25rem 0.75rem;
    }
  }
}
</style>
